'use strict';
import { module } from '../app';

module.controller('PatientDetailsCtrl', [
  '$scope', '$stateParams', 'patientDetailsViewModel', 'signalrService', '$state', '$location',
  async function ($scope, $stateParams, patientDetailsViewModel, signalrService, $state, $location) {
    const self = this;
    const isViewOnly = $location.search().viewOnly;

    if (!signalrService.isConnected) {
      if (!signalrService.isConnected) {
        if (!self.reconnectTimeout) {
          self.reconnectTimeout = setTimeout(() => {
            signalrService.tryReconnectAgain();
          }, 10000);
        }

        await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);
        $state.goBack();
        return;
      }
    }
    const accessToken = $stateParams.accessToken;
    $scope.vm = new patientDetailsViewModel(accessToken, isViewOnly);
    $scope.vm.initializeData();
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/patientDetails.js